export interface RoleRef {
  id: number;
  name: string;
}

export interface Authority {
  id: number;
  name: string;
  visible?: boolean;
}

export interface Role {
  id: number;
  name: string;
  authorities: Authority[];
  canBeModified: boolean;
}

export type UserStatus =
  | "PENDING"
  | "REGISTRATION_PENDING"
  | "REGISTRATION_REJECTED"
  | "APPROVED"
  | "UNVARIFIED"
  | "REJECTED";

export interface User {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string;
  createdAt: string | null;
  lastModifiedDate: string | null;
  status: UserStatus;
  comments: string | null;
  enabled: boolean;
  /** False for someone who signed up and never confirmed their address. */
  emailConfirmed: boolean;
  roles: RoleRef[];
}

export type ProfileSection = "about" | "location" | "church" | "clergy" | "laity";

export interface ProfileField {
  section: ProfileSection;
  key: string;
  label: string;
  /** Null when the registrant left it blank. */
  value: string | null;
}

export interface ProfileChange {
  key: string;
  label: string;
  current: string | null;
  proposed: string | null;
}

export interface RegistrantProfile {
  userId: number;
  /** False for an account with no registration form behind it, e.g. one an administrator created. */
  submitted: boolean;
  submittedAt?: string | null;
  fields: ProfileField[];
  /** An edit to their profile that is waiting for approval. */
  changes: ProfileChange[];
}

export interface Page<T> {
  total: number;
  totalPage: number;
  currentPage: number;
  data: T[];
}

export interface UserQuery {
  pageNumber: number;
  pageSize: number;
  sort: "ASC" | "DESC";
  sortOn: string;
  search: string;
  status: string;
  roles: string;
  /** "true" hides unconfirmed signups, "false" shows only them, "any" shows all. */
  emailConfirmed: "true" | "false" | "any";
}

export const DEFAULT_USER_QUERY: UserQuery = {
  pageNumber: 0,
  pageSize: 25,
  sort: "DESC",
  sortOn: "lastModifiedDate",
  search: "",
  status: "",
  roles: "",
  emailConfirmed: "true",
};
